import { render } from "./LocalVideoFullscreenButton.vue?vue&type=template&id=26fc9cee"
import script from "./LocalVideoFullscreenButton.vue?vue&type=script&lang=ts"
export * from "./LocalVideoFullscreenButton.vue?vue&type=script&lang=ts"

import "./LocalVideoFullscreenButton.vue?vue&type=style&index=0&id=26fc9cee&lang=scss"
script.render = render

export default script